import { IPromoPopup } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export const selectPromoDetails = (state: IApplicationState): IPromoPopup | null => {
  return state.promoDetails.promo;
};
